import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userid: { id: 'abc', name: 'farshad' }
    },
    mutations: {},
    actions: {},
    getters:{
        length: state => {
            return state.userid.name
        }
    }
})